import { formatOgsDollar } from "opp-api-lib-js";
export default formatOgsDollar;



// WEBPACK FOOTER //
// ./src/utils/formatOgsDollar.ts